import api from "@/api";

export default {
  getCurrentPage: () => {
    return api
      .get("/family/currentPage")
      .then((response) => response);
  },
  getFamilyRoles: () => {
    return api
      .get("/family/roles")
      .then((response) => response);
  },
  join: (familyRef, code, nickname, role, recaptcha) => {
    return api
      .post("/family/join", { familyRef, code, nickname, role, recaptcha })
      .then((response) => response);
  },
  getHoldTime: () => {
    return api
      .get("/family/hold")
      .then((response) => response);
  },
  post: (familyName, nickname, role, recaptcha) => {
    return api
      .post("/family", { familyName, nickname, role, recaptcha })
      .then((response) => response);
  },
  get: (lang) => {
    return api
      .get("/family/family?lang=" + lang)
      .then((response) => response);
  },
  getRequest: (lang) => {
    return api
      .get("/family/request?lang=" + lang)
      .then((response) => response);
  },
  postHandleRequest: (familyId, memberId, actions, lang) => {
    return api
      .post("/family/handle-request", { familyId, memberId, actions, lang })
      .then((response) => response);
  },
  postRegenFamilyCode: (familyId) => {
    return api
      .post("/family/regen-family-code", { familyId })
      .then((response) => response);
  },
  postLeaveFamily: (familyId) => {
    return api
      .post("/family/leave-family", { familyId })
      .then((response) => response);
  },
  postDismissFamily: (familyId) => {
    return api
      .delete("/family/dismiss-family?familyId=" + familyId,)
      .then((response) => response);
  },
  getPermission: () => {
    return api
      .get("/family/permission")
      .then((response) => response);
  },
  postUpdateInfo: (familyId, nickname, familyRole, lang, familyName) => {
    return api
      .post("/family/update-info", { familyId, nickname, familyRole, lang, familyName })
      .then((response) => response);
  },
  postDirectCreate: (recaptcha) => {
    return api
      .post("/family/direct-create", { recaptcha })
      .then((response) => response);
  },
  postAdminJoin: (nonce, cipher, recaptcha) => {
    return api
      .post("/family/admin-join", { nonce, cipher, recaptcha })
      .then((response) => response);
  },
  postMemberJoin: (familyRef, code) => {
    return api
      .post("/family/member-join", { familyRef, code })
      .then((response) => response);
  },
  getMultiple: (lang) => {
    return api
      .get("/family/multiple?lang=" + lang)
      .then((response) => response);
  },
  postKeepFamily: (familyId) => {
    return api
      .post("/family/keep-family", { familyId })
      .then((response) => response);
  },
  getPublicKey: () => {
    return api
      .get("/family/public-key")
      .then((response) => response);
  },
};